// 转弯模式
export default {
    fixedPoint: '定点转弯',
    coordinate: '协调转弯'
}